import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

interface StateListComponentProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  onBlur?: () => void;
  error?: boolean;
}

const stateList = Object.freeze([
  {
    id: 'QD',
    value: 'Queued',
  },
  {
    id: 'IP',
    value: 'In Progress',
  },
  {
    id: 'KO',
    value: 'Errore',
  },
]);

const StateListComponent = ({
  disabled,
  onChange,
  onBlur = () => {
    return;
  },
  value,
  error,
  required,
}: StateListComponentProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="subscriber-label">
        {required ? 'Stato *' : 'Stato'}
      </InputLabel>
      <PmiSelect
        labelId="state-label"
        id="state"
        name="state"
        value={value}
        label={required ? 'Stato *' : 'Stato'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        onBlur={onBlur}
      >
        <MenuItem value="">
          <em>Tutti</em>
        </MenuItem>
        {stateList.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

StateListComponent.displayName = 'State item component';

const StateList = memo(StateListComponent);

export default StateList as typeof StateListComponent;
